import React, { useState, useEffect } from "react";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Skill from "../component/hiredeveloper/skill";
import close from "../images/hireDeveloper/close.svg";
import Experience from "../component/hiredeveloper/experience";
import Startwork from "../component/hiredeveloper/startwork";
import Longwork from "../component/hiredeveloper/longwork";
import Userinfo from "../component/hiredeveloper/userinfo";
import Jobdescription from "../component/hiredeveloper/jobdescription";
import Userdetails from "../component/hiredeveloper/userdetails";
import MeetingSchedule from "../component/hiredeveloper/meetingSchedule";
import moment from "moment";
import momentTimeZone from "moment-timezone";
import axios from "axios";
import {
  experience,
  longwork,
  skillData,
  startwork,
} from "../component/hiredeveloper/constdata";
import config from "../config";

const steps = [
  "Select Skill",
  "Choose Experience",
  "When to start?",
  "Period of Hiring",
  "Your Information",
  "Job Description",
];

const BASE_IP_URL =
  process.env.IP_URL || "https://ipinfo.io/?token=9415d554205624";

const HireDeveloper = () => {
  const [requiremntID, setRequiremntID] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [pageData, setPageData] = useState({
    skill: [],
    experience: "less3",
    startwork: "as_soon_as_possible",
    longwork: "less_1_month",
    userinfo: "",
    jobdescription: { name: "No file chosen...", requirements: "" },
    skillname: "",
    anotherSkill: "",
  });
  const [isHovered, setIsHovered] = useState(false);

  // ✅ add ipData state
  const [ipData, setIpData] = useState(null);

  const style = {
    backgroundColor: isHovered ? "red" : "#104c96",
    opacity: 1,
    padding: "10px", // Example additional styling
    transition: "background-color 0.3s", // Smooth transition for hover effect
  };
  const navigate = useNavigate();
  useEffect(() => {
    document.body.className = "lightBG";
    document.title =
      "Hire The Highly Skilled Remote Developers | Hire Remote Team";
    document.querySelector("meta[name='description']").content =
      "Hire highly skilled remote developers, 3 - 5+ Years of Experience preferable that you can rely on and which synchronizes with your time zone. Contact us!";

    // ✅ Fetch IP data once on mount
    const fetchIpData = async () => {
      try {
        const res = await axios.get(BASE_IP_URL);
        setIpData(res.data);
      } catch (err) {
        console.error("Failed to fetch IP data:", err);
        setIpData("IP data not available");
      }
    };
    fetchIpData();
  }, []);

  const routeChange = async () => {
    const filterSkill = skillData
      .filter((s) => pageData.skill.includes(s.id))
      .map((_s) => _s.name);
    const filterExp = experience.find(
      (e) => pageData.experience === e.value
    ).label;
    const filterStartwork = startwork.find(
      (w) => pageData.startwork === w.value
    ).label;
    const filterLongwork = longwork.find(
      (l) => pageData.longwork === l.value
    ).label;
    if (pageData.jobdescription.size) {
      var file = pageData.jobdescription.baseFile;
      var fileName = pageData.jobdescription.name;
    }
    const developerData = {
      ...pageData,
      skill: filterSkill,
      jobdescription: {
        file,
        fileName,
        requirements: pageData.jobdescription.requirements,
      },
      experience: filterExp,
      startwork: filterStartwork,
      longwork: filterLongwork,
      clientIpData: ipData || "IP data not available",
    };
    if (developerData?.anotherSkill) {
      // developerData.skill.push("");
      developerData.skill.push(" " + developerData.anotherSkill);
    }
    const d = await axios.post(
      `${config.baseUrl}/hiredeveloper`,
      developerData
    );
    setRequiremntID(d.data.data._id);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const isValid = () => {
    switch (activeStep) {
      case 0:
        if (pageData.skill.includes(11)) {
          return Boolean(pageData.anotherSkill);
        } else return pageData.skill.length ? true : false;
      case 3:
        if (pageData.longwork === "other" && !pageData.skillname) return false;
        else return true;
      case 4:
        const emailTest = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (pageData.userinfo.name && emailTest.test(pageData.userinfo.email))
          return true;
        else return false;
      case 5:
        if (
          pageData.jobdescription.type ||
          pageData.jobdescription.requirements
        )
          return true;
        else return false;
      default:
        return true;
    }
  };

  const handleNext = () => {
    const valid = isValid();
    if (valid) setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if ((prevActiveStep) => prevActiveStep <= 5) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const saveData = (id, value) => {
    if (id.includes(11)) {
      setPageData({ ...pageData, [id]: pageData.anotherSkill });
    } else {
      setPageData({ ...pageData, [id]: value });
    }
  };

  return (
    <>
      <div className="hireMainSection">
        <section className="hireHeader">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Hire Skilled Remote Developer</h2>
                <Link
                  to="/"
                  className="close"
                  style={style}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <img
                    src={close}
                    style={{ filter: "brightness(0) invert(1)" }}
                    alt="Hire Resources"
                  />
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section
          className={
            activeStep >= 6 ? "progressSection d-none" : "progressSection"
          }
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Box sx={{ width: "100%" }} className="progressBar">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel className="progressLabel" title={label}>
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </div>
          </div>
        </section>

        {activeStep === 0 ? (
          <Skill
            data={pageData.skill}
            onSave={saveData}
            anotherSkill={pageData.anotherSkill}
          />
        ) : null}
        {activeStep === 1 ? (
          <Experience data={pageData.experience} onSave={saveData} />
        ) : null}
        {activeStep === 2 ? (
          <Startwork data={pageData.startwork} onSave={saveData} />
        ) : null}
        {activeStep === 3 ? (
          <Longwork
            data={pageData.longwork}
            onSave={saveData}
            skillname={pageData.skillname}
          />
        ) : null}
        {activeStep === 4 ? (
          <Userinfo data={pageData.userinfo} onSave={saveData} />
        ) : null}
        {activeStep === 5 ? (
          <Jobdescription data={pageData.jobdescription} onSave={saveData} />
        ) : null}
        {activeStep === 6 ? <Userdetails data={pageData} /> : null}
        {activeStep === 7 ? <MeetingSchedule id={requiremntID} /> : null}
        {activeStep !== 7 ? (
          <section className="processBtn">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <button onClick={handleBack} disabled={activeStep === 0}>
                    <span>Back</span>
                  </button>
                  {activeStep === 6 ? (
                    <button onClick={routeChange}>
                      <span>Finish</span>
                    </button>
                  ) : (
                    <button disabled={!isValid()} onClick={handleNext}>
                      <span>Next</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </section>
        ) : null}
      </div>
    </>
  );
};

export default HireDeveloper;
